export default "__VITE_ASSET__DzvqMs8j__"